import { BackButton, Fieldset, Loading, Subsection } from '@fourthwall/components';
import React from 'react';
import { Dashboard, PageLayout } from '@components/common';
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar';
import { routing } from '@utils/routing';
import { HelpfulResources } from './components/HelpfulResources';
import { useTierContext } from './hooks/useTierContext';
import { AskForShippingAddress } from './modules/AskForShippingAddress';
import { Description } from './modules/Description';
import { Discount } from './modules/Discount';
import { DiscountType } from './modules/DiscountType/DiscountType';
import { Image } from './modules/Image';
import { InternationalPricing } from './modules/InternationalPricing';
import { MonthDiscount } from './modules/MonthDiscount';
import { Price } from './modules/Price';
import { TimeLimit } from './modules/TimeLimit';
import { Title } from './modules/Title';
import { YearDiscount } from './modules/YearDiscount';
import { TierProvider } from './providers/TierProvider';
const TierCreateContent = () => {
    const { form, isLoading, isPriceRatesLoading } = useTierContext();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    return (React.createElement(Loading, { isLoading: isLoading },
        React.createElement(PageLayout, { leftContent: React.createElement(React.Fragment, null,
                React.createElement(Subsection, { title: "Tier details" },
                    React.createElement(Fieldset, null,
                        React.createElement(Title, null),
                        React.createElement(Description, null),
                        React.createElement(Image, null))),
                React.createElement(Subsection, { title: "Pricing" },
                    React.createElement(Fieldset, null,
                        React.createElement(Price, null),
                        React.createElement(InternationalPricing, null),
                        React.createElement(Discount, null),
                        React.createElement(DiscountType, null),
                        React.createElement(MonthDiscount, null),
                        React.createElement(YearDiscount, null),
                        React.createElement(TimeLimit, null))),
                dashboardFeatureFlags.membershipsShippingAddress.enabled && (React.createElement(Subsection, { title: "Advanced" },
                    React.createElement(AskForShippingAddress, null)))), rightContent: React.createElement(HelpfulResources, null) },
            React.createElement(Dashboard.Section, { name: "Add a new membership tier", topContent: React.createElement(BackButton, { label: "Perks & tiers", to: routing.memberships.perks.self }), titleSpacing: "medium", bottomMargin: "large" })),
        React.createElement(LeavingGuard, { when: form.dirty, isValid: form.isValid, onSave: form.submitForm }),
        React.createElement(ConfirmBar, { isOpen: form.dirty, isLoading: isLoading || isPriceRatesLoading, onConfirm: form.submitForm, onCancel: form.resetForm })));
};
export const TierCreate = () => {
    return (React.createElement(TierProvider, null,
        React.createElement(TierCreateContent, null)));
};
